import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=4dec096c&scoped=true&"
import script from "./AdminFooter.vue?vue&type=script&lang=js&"
export * from "./AdminFooter.vue?vue&type=script&lang=js&"
import style0 from "./AdminFooter.vue?vue&type=style&index=0&id=4dec096c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec096c",
  null
  
)

export default component.exports